export default __webpack_public_path__ + "static/media/cn_amp_pic_red.663e211a.webp";